<template>
  <div>
    <v-container fluid class="fin-color-primary-light">
      <!--TODO get rid of this spacings -->
      <v-row dense class="pt-10 ml-n4"
             v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
             v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
        <!--v-col cols="12" v-if="portfoliosWithInstrument" class="px-0 ">

          <fin-message :color="$finColors.accentGreen" :dismissible="true" icon="icon-information">
            <p>Du hast dieses Wertpapier bereits hinzugefügt.</p>
            <ul class="portfolios-with-instrument">
              <li :key="item.portfolio.id" v-for="item in portfoliosWithInstrument"
                  @click="$emit('openPortfolio', item.portfolio.id)">
                {{ item.portfolio.name }}
              </li>
            </ul>
          </fin-message>

        </v-col-->
        <v-col cols="12" md="8">
          <h1 class="d-inline-block">{{ instrument.name }}</h1>
          <fin-realtime-indicator v-if="isActiveShare" class="realtime" trading-platform="tradegate"
                                  :instruments="[instrument]"/>
        </v-col>
        <v-spacer/>
        <v-col v-if="isActiveShare"
               cols="12" md="4"
               class="d-flex justify-end align-start">
          <fin-instrument-contextmenu :instrument="instrument" v-if="!noEscapeLink" :actions="actions"/>
        </v-col>
        <v-col cols="12" v-if="subLineValues" class="mt-n4 d-flex align-center">
          <fin-data-table :headers="subLineValues"
                          :mobile-breakpoint="Number.MAX_SAFE_INTEGER"
                          :resolver="[instrument]"
                          hide-default-footer
                          hide-default-header
                          transparent
                          disable-row-hover
                          ref="subLineValuesTable"
          />
          <fin-lexicon-link icon="mdi-minus-circle"
                            to="inaktives-wertpapier"
                            v-if="!isActiveShare"/>
        </v-col>
        <v-col cols="auto">
          <v-row :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row'" class="d-flex flex-wrap pb-8">
            <v-col v-if="currentValue" class="my-n2 d-flex" cols="auto">
              <fin-portfolio-value-change :addSign="false"
                                          :from="instrument.close"
                                          :to="instrument.latestPrice ? instrument.latestPrice.price : instrument.close"
                                          :value-date="instrument.latestPrice ? instrument.latestPrice.timestamp : instrument.closeDate"
                                          :value-date-prefix="`Börse ${instrument.latestPrice.exchangeName}:`"
                                          class="flex"
                                          color="var(--night-blue)"
                                          hint="Differenz Vortag"
                                          title="Aktueller Kurs"
                                          v-if="(instrument.latestPrice && instrument.latestPrice.price) || instrument.close"
              />
            </v-col>
            <v-col v-if="dailyData" class="my-n2 d-flex" cols="auto">
              <v-card class="portfolio-value-box v-card v-sheet theme--light px-8 py-4 elevation-4 hard flex" style="">
                <div class="portfolio-value-box__title">TAGESENTWICKLUNG</div>
                <fin-data-table ref="dailyDataTable"
                                :headers="dailyData"
                                :mobile-breakpoint="Number.MAX_SAFE_INTEGER"
                                :resolver="[instrument]"
                                class="dailyData"
                                disable-row-hover
                                hide-default-footer
                                hide-default-header
                                transparent
                />
              </v-card>
            </v-col>
            <v-col v-if="keyFigures" class="my-n2 d-flex" cols="auto">
              <fin-data-table ref="keyFiguresTable"
                              :headers="keyFigures"
                              :mobile-breakpoint="Number.MAX_SAFE_INTEGER"
                              :resolver="[instrument]"
                              class="keyFigures"
                              disable-row-hover
                              hide-default-footer
                              hide-default-header
                              transparent
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <fin-tabs v-if="tabs"
              :no-item-content-padding="true"
              :selectedTab="selectedTab"
              :tab-items="tabs"
              @tabChangeNotAllowed="(val, index) => tabChangeNotAllowed(val, index)"
              @tabChanged="(tab) => selectTab(tab)">
      <template #[index] v-for="(tab, index) in tabs">
        <slot :name="`tab${index}`" :instrument="instrument">
          <fin-work-in-progress/>
        </slot>
      </template>
    </fin-tabs>


  </div>
</template>

<script>
import FinTabs from "@/components/common/Tabs"
import FinWorkInProgress from "@/components/common/WorkInProgress"
import HeaderValueRender from "@/mixins/HeaderValueRender"
import FinDataTable from "@/components/common/DataTable/FinDataTable"
import FinInstrumentContextmenu from "@/components/pages/instrumentPages/instrumentDetailPage/FinInstrumentContextmenu"
import FinRealtimeIndicator from "@/components/common/RealtimeIndicator"
import FinPortfolioValueChange from "@/components/pages/myPortfolio/PortfolioValueChange"
import FinLexiconLink from "@/components/common/lexicon/LexiconLink"
import {EventBus} from "@/plugins/fincraft"
import {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"

export default {
  name: "finInstrumentDetailHeader",
  components: {
    FinPortfolioValueChange,
    FinRealtimeIndicator,
    FinInstrumentContextmenu,
    FinDataTable,
    FinWorkInProgress,
    FinTabs,
    FinLexiconLink
  },
  mixins: [HeaderValueRender],
  props: {
    actions: {
      type: Array
    },
    noEscapeLink: {
      type: Boolean
    },
    instrument: {},
    tabs: {
      type: Array
    },
    subLineValues: {
      type: [Array, Object],
    },
    keyFigures: {
      type: [Array, Object],
    },
    dailyData: {
      type: [Array, Object]
    },
    currentValue: {
      type: Boolean,
    }
  },
  data() {
    return {
      selectedTab: 0
    }
  },
  methods: {
    tabChangeNotAllowed(tab) {
      if (tab.id === 'KEY_FIGURES') {
        EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.KEY_FIGURES.id, PRICEMODEL_FEATURE_RESTRICTIONS.UNAVAILABLE)
      }
    },
    selectTab(tab) {
      this.selectedTab = tab
    }
  },
  computed: {
    exchangeName() {
      return this.instrument?.latestPrice?.exchangeName
    },
    portfoliosWithInstrument() {
      return this.instrument?.portfolioEntries?.items
    },
    isActiveShare() {
      if(!this.instrument.active || !this.instrument.covered || this.instrument.delisted) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    instrument: {
      handler() {
        this.$refs.keyFiguresTable._fetchData()
        this.$refs.subLineValuesTable._fetchData()
        this.$refs.dailyDataTable._fetchData()
      },
      deep: true
    }
  }
}
</script>


<style lang="scss" scoped>
::v-deep {
  /*
    .fin-data-table td {
      .mobile-header {
        font-size: 0.9em !important;
        text-transform: uppercase !important;
        font-weight: 600 !important;
        font-stretch: normal !important;
        font-style: normal !important;
        line-height: 1.17 !important;
        letter-spacing: 1px !important;
        margin-bottom: 8px;
        margin-top: 8px;
      }

      .box-card {
        float: left;
      }
    }*/
}

.dailyData ::v-deep {
  .fin-data-table td {
    .row {
      box-shadow: none !important;
    }

    .col {
      padding: 0 8px !important
    }

    .paragraph {
      font-size: 16px !important;
      font-family: $body-font-family;
      text-transform: capitalize !important;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 1px;
      color: $fin-color-primary-dark;
    }

    .value {
      font-weight: bold !important;
      font-stretch: normal !important;
      font-style: normal !important;
      letter-spacing: normal !important;
    }
  }
}

.keyFigures ::v-deep {
  .fin-data-table td {
    .value {
      font-size: 20px !important;
      font-weight: bold !important;
      font-stretch: normal !important;
      font-style: normal !important;
      letter-spacing: normal !important;
    }

    .paragraph {
      font-size: 12.6px !important;
      font-family: $body-font-family;
      text-transform: uppercase !important;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.17;
      letter-spacing: 1px;
      color: $fin-color-primary-dark;
    }
  }
}

.portfolio-value-box__title {
  font-family: $body-font-family;
  font-size: 0.9em;
  text-transform: uppercase !important;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 1px;
  color: $fin-color-primary-dark;
}

.realtime {
  position: relative !important;
  top: -7px !important;
  left: 5px !important;
}

/*.portfolios-with-instrument {
  list-style: none outside !important;
  margin-left: -25px;

  a {
    color: $fin-color-primary-dark;
    font-weight: 500;
    text-decoration: none;
  }
}*/
</style>
